import "./HeaderLogged.scss";
import React, { useState } from "react";
import {
  Link,
  Popover,
  Stack,
  createTheme,
  IconButton,
  useMediaQuery,
  Container,
} from "@mui/material";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import { useTranslation } from "react-i18next";
import { ThemeProvider } from "@mui/system";
import Button from "@mui/material/Button";
import LoggedMenu from "../LoggedMenu/LoggedMenu";
import { MyProfileWrapper, MyProfile } from "./MyProfile/MyProfile";

function HeaderLogged() {
  // Translation
  const { t } = useTranslation();
  const [isMenuExpanded, setIsMenuExpanded] = useState<boolean>(false);
  const isDesktopViewport = useMediaQuery("(min-width:1100px)");
  const profileMenu = createTheme({
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: "12px",
            boxShadow: "0px 3px 5px 0px rgba(55, 70, 73, 0.20)",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            padding: "0",
          },
        },
      },
    },
  });

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    !isDesktopViewport && document.body.classList.add("scroll-disabled");
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIsMenuExpanded(false);
    document.body.classList.remove("scroll-disabled");
  };

  const open = Boolean(anchorEl);
  const showProfileIcon = !!(isMenuExpanded || (open && !isDesktopViewport));
  const profile = open ? "simple-popover" : undefined;

  const handleBurgerMenuClick = () => {
    if (open) {
      handleClose();
      return;
    }

    setIsMenuExpanded(!isMenuExpanded);

    if (!isMenuExpanded) {
      document.body.classList.add("scroll-disabled");
      return;
    }

    document.body.classList.remove("scroll-disabled");
  };

  return (
    <header className="App-header">
      <Container>
        <Stack
          direction="row"
          justifyContent="space-between"
          className="header-stack"
          alignItems="center"
        >
          <Stack direction="row">
            <Link href="/">
              {/* Logo */}
              <img
                src={process.env.PUBLIC_URL + "/TotalEnergies.svg"}
                className="App-logo"
                alt="logo"
              />
            </Link>
            {/* Main menu */}
            <Stack
              direction="column"
              alignItems="center"
              justifyContent="space-between"
              gap="2rem"
              className={`tabs-container ${
                isMenuExpanded && "tabs-container--active"
              }`}
            >
              <LoggedMenu
                isDesktopViewport={isDesktopViewport}
                handleClose={() => handleClose()}
              />
              <Stack
                className="dnone-desktopheader"
                paddingLeft="1rem"
                marginBottom="15vh"
              >
                <LanguageSelector />
              </Stack>
            </Stack>
          </Stack>
          {/* Header Mobile */}
          <Stack
            direction="row"
            display={{ xs: "flex", headerMobile: "none" }}
            alignItems="center"
            gap="1.5rem"
          >
            <Button
              aria-describedby={profile}
              onClick={handleClick}
              disableRipple
              id="basic-button"
              aria-label={t("Header.Nav.Perfil")}
              style={{ alignSelf: "center", padding: "0", minWidth: "0px" }}
              className={`${
                (showProfileIcon || open || isMenuExpanded) && "d-none"
              }`}
            >
              <div className="notification-button" style={{ color: "#161C1F" }}>
                <div
                  className="t-icon-user brand-red"
                  style={{ fontSize: "20px" }}
                />
              </div>
            </Button>

            {/* <Notifications
              isNotificationsOpen={isNotificationOpen}
              setIsNotificationsOpen={setIsNotificationOpen}
              notificationsCount={notificationsCount}
              setNotificationsCount={setNotificationsCount}
            />
            <Button
              onClick={() => setIsNotificationOpen(true)}
              disableRipple
              id="basic-button"
              aria-label={t("Header.Nav.Notificaciones")}
              style={{
                alignSelf: "center",
                padding: "0",
                minWidth: "0px",
              }}
            >
              <div className="notification-button">
                <div
                  className="t-icon-bell brand-red"
                  style={{ fontSize: "20px" }}
                />
              </div>
            </Button> */}

            <IconButton
              disableRipple
              className="burger-menu"
              onClick={handleBurgerMenuClick}
            >
              <span
                className={`${
                  isMenuExpanded || open ? "t-icon-close" : "t-icon-burger_menu"
                } brand-red`}
                style={{ fontSize: "20px" }}
              />
            </IconButton>
          </Stack>
          {/* Fin Header Mobile */}
          <Stack
            direction="row"
            gap="1.5rem"
            display={{ xs: "none", headerMobile: "flex" }}
          >
            {/* User profile menu */}
            <ThemeProvider theme={profileMenu}>
              <Button
                disableRipple
                aria-describedby={profile}
                onClick={handleClick}
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                style={{ alignSelf: "center" }}
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  className={anchorEl ? "ls-open" : "ls-box"}
                  borderRadius="8px"
                  padding="0.5rem"
                  display={{ xs: "none", md: "flex" }}
                >
                  <div
                    className="t-icon-user brand-red ls-icon"
                    style={{ fontSize: "20px", paddingRight: "8px" }}
                  />
                  <span className="brand-gray pm-text">
                    {t("Header.Nav.Perfil")}
                  </span>
                  <div
                    className={`${
                      anchorEl ? "rotate-icon" : ""
                    } brand-red t-icon-arrow-dropdown ls-icon`}
                  />
                </Stack>
              </Button>
            </ThemeProvider>

            {/* Notifications */}

            {/* <Button
              onClick={() => setIsNotificationOpen(true)}
              disableRipple
              id="basic-button"
              aria-label={t("Header.Nav.Notificaciones")}
              style={{ alignSelf: "center", padding: "8px" }}
            >
              <div className="notification-button">
                <Badge
                  badgeContent={notificationsCount}
                  className="notification-button"
                  style={{ color: "#161C1F" }}
                >
                  <div
                    className="t-icon-bell brand-red"
                    style={{ fontSize: "20px" }}
                  />
                </Badge>
              </div>
            </Button> */}

            {/* Lang menu */}

            <LanguageSelector />
          </Stack>
          <MyProfileWrapper
            isDesktopViewport={isDesktopViewport}
            isMenuOpen={open}
            wrapper={(children) => (
              <Popover
                id={profile}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                {children}
              </Popover>
            )}
          >
            <MyProfile
              isDesktopViewport={isDesktopViewport}
              handleClose={handleClose}
            />
          </MyProfileWrapper>
        </Stack>
      </Container>
    </header>
  );
}

export default HeaderLogged;
